module.exports = __webpack_public_path__ + "static/img/book2.56bdd15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book2.jpg
// module id = AKUK
// module chunks = 1